import { useState, useEffect, useRef } from "react";
import { withLocalize } from "react-localize-redux";
import { FiChevronDown } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { setProject } from "../../../utils/redux/app/appActions";

const Dropdown = ({ translate }) => {
  const [selected, setSelected] = useState("");
  const [query, setQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const inputRef = useRef(null);

  const {projects, project} = useSelector(state => state.app)
  const dispatch = useDispatch();

  const handleSelect = (project) => {
    setSelected(project.name);
    setQuery(project.name);
    dispatch(setProject(project));
  };

  useEffect(() => {
    if (projects.length && isLoading) {
      setIsLoading(false);

      if (project) {
        setSelected(project.name);
        setQuery(project.name);
      }
    }

    return () => {
      if (!isLoading) setIsLoading(true);
    };
  }, [isLoading, projects, project]);

  return projects?.length < 1 ? null : (
    <div className="dashboard-project-dropdown position-relative d-flex justify-content-between align-items-center">
      {!selected && (
        <label
          htmlFor={"project-input"}
          className="position-absolute"
          id="project-input-label"
        >
          {translate(isLoading ? `loading` : "dashboard.select_a_project")}
        </label>
      )}
      <div className="width-fix opacity-0 mx-2" aria-hidden="true">
        {query}
      </div>
      <input
        type="text"
        id="project-input"
        value={query}
        onChange={({ target }) => setQuery(target.value)}
        autoComplete="off"
        onFocus={() =>
          !isLoading &&
          document
            .querySelector("#project-input-label")
            ?.classList?.add("focused")
        }
        onBlur={() => {
          const labelEl = document.querySelector("#project-input-label");
          !query && labelEl && labelEl.classList.remove("focused");
        }}
        disabled={isLoading}
        ref={inputRef}
        className={`position-absolute p-0`}
      />
      <button
        className="p-0 m-0 border-0 rounded-circle position-relative"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const el = document.querySelector("#project-input");

          if (el) {
            el.focus();
          }
        }}
        disabled={isLoading}
      >
        <FiChevronDown />
      </button>
      {!isLoading && (
        <div className="list-holder position-absolute d-flex flex-column align-items-start">
          {projects
            .filter((project) =>
              query && query !== selected
                ? project.name
                    .toLowerCase()
                    .trim()
                    .includes(query.toLowerCase().trim())
                : true
            )
            .map((project) => (
              <div
                key={project.id}
                role="button"
                className="list-item text-start"
                onClick={() => handleSelect(project)}
              >
                {project.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default withLocalize(Dropdown);
